import { useEffect } from 'react';
import { useThemeStore } from '@/lib/theme.store';
import { tenantsApi } from '../api/tenants.api';

/**
 * Holt die Mandanten-Primärfarbe und reicht sie an den Theme-Store weiter.
 *
 * Rendert nichts. Die Richtung ist Absicht: das Feature kennt den geteilten
 * Theme-Layer, nicht umgekehrt — und der Store bleibt die einzige Stelle, die
 * CSS-Variablen auf :root schreibt.
 *
 * Wird nur innerhalb geschützter Routen gerendert, weil `/tenants/me`
 * Authentifizierung braucht. Schlägt der Aufruf fehl (offline, 401), bleibt die
 * zuletzt bekannte Farbe aus dem Theme-Snapshot stehen.
 */
export function TenantBrandingSync() {
  const setTenantAccent = useThemeStore((s) => s.setTenantAccent);

  useEffect(() => {
    let cancelled = false;
    tenantsApi
      .getMe()
      .then(({ data }) => {
        if (cancelled) return;
        const color = data.settings?.primaryColor;
        setTenantAccent(typeof color === 'string' && color ? color : null);
      })
      .catch(() => {
        // Kein Zurücksetzen im Fehlerfall — sonst blitzt bei jedem Netzproblem
        // die Theme-Farbe auf, obwohl der Mandant eine Firmenfarbe gesetzt hat.
      });
    return () => { cancelled = true; };
  }, [setTenantAccent]);

  return null;
}
